/* Local dependencies */
import { Amount, Location, Order, Store } from '../../../shared/types';

export enum CreateOrderActionTypes {
  CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST',
  CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS',
  CREATE_ORDER_ERROR = 'CREATE_ORDER_ERROR',
  RESET_ERROR = 'RESET_CREATE_ORDER_ERROR',
  RESET_CREATE_ORDER_STATE = 'RESET_CREATE_ORDER_STATE',
  UPDATE_CREATE_ORDER_FIELDS = 'UPDATE_CREATE_ORDER_FIELDS',
  VALIDATION_ALL_FIELDS = 'VALIDATION_ALL_FIELDS',
}

export interface CreateOrderInput {
  amount: Amount;
  deliveryAddress?: Location;
  name: string;
  parcelCount: number;
  trackingNumber: string;
  store?: Store;
  userId?: string;
  warehouseId?: string;
}

export interface CreateOrderRequest {
  type: CreateOrderActionTypes.CREATE_ORDER_REQUEST;
  input: CreateOrderInput;
}

export interface CreateOrderSuccess {
  type: CreateOrderActionTypes.CREATE_ORDER_SUCCESS;
  order: Order;
}

export interface CreateOrderError {
  type: CreateOrderActionTypes.CREATE_ORDER_ERROR;
  error: Error;
}

export interface ResetError {
  type: CreateOrderActionTypes.RESET_ERROR;
}

export interface UpdateCreateOrderFields {
  type: CreateOrderActionTypes.UPDATE_CREATE_ORDER_FIELDS;
  fields: Partial<CreateOrderFormFields>;
}

export interface ResetCreateOrderState {
  type: CreateOrderActionTypes.RESET_CREATE_ORDER_STATE;
}

export interface ValidationAllFieldsOptions {
  requireUser?: boolean;
  requireWarehouse?: boolean;
}

export interface ValidationAllFields {
  type: CreateOrderActionTypes.VALIDATION_ALL_FIELDS;
  options?: ValidationAllFieldsOptions;
}

export interface CreateOrderFormFields {
  trackingNumber: string;
  name: string;
  parcelCount: number;
  amount: Amount;
  store: Store;
  deliveryAddress: Location;
  userId?: string;
  warehouseId?: string;
}

export interface ValidationErrors {
  trackingNumber?: string;
  name?: string;
  parcelCount?: string;
  amount?: string;
  deliveryAddress?: string;
  userId?: string;
  warehouseId?: string;
}

export interface CreateOrderState {
  order: CreateOrderFormFields;
  success: boolean;
  loading: boolean;
  error?: Error;
  validationErrors: ValidationErrors;
}

export type CreateOrderAction =
  | CreateOrderRequest
  | CreateOrderSuccess
  | CreateOrderError
  | ResetError
  | UpdateCreateOrderFields
  | ResetCreateOrderState
  | ValidationAllFields;
